module.exports = "/lucky-balls/img/bonus_yellow/header_oktagon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_oktagon.png
// module id = 968
// module chunks = 0